import React from 'react';
import { Code, Database, Settings, Headphones } from 'lucide-react';
import { services } from '../data/mock';

const iconMap = {
  Code: Code,
  Database: Database,
  Settings: Settings,
  Headphones: Headphones
};

const ServicesSection = () => {
  return (
    <section id="servicos" className="relative py-24 bg-black">
      {/* Background elements */}
      <div className="absolute inset-0 bg-gradient-to-b from-cyan-950/10 via-transparent to-transparent" />
      
      <div className="relative max-w-7xl mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-cyan-400/10 border border-cyan-400/20 mb-6">
            <span className="text-cyan-400 text-sm font-medium">Nossos Serviços</span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6">
            Soluções completas em <span className="text-cyan-400">tecnologia</span>
          </h2>
          <p className="text-white/60 text-lg max-w-2xl mx-auto">
            Oferecemos uma gama completa de serviços para atender todas as necessidades tecnológicas da sua empresa.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div
                key={service.id}
                className="group relative p-8 bg-white/[0.02] border border-white/10 hover:border-cyan-400/50 transition-all duration-400 hover:bg-cyan-400/5"
              >
                {/* Service number */}
                <div className="absolute top-8 right-8 text-5xl font-bold text-white/5 group-hover:text-cyan-400/10 transition-colors">
                  0{index + 1}
                </div>
                
                {/* Icon */}
                <div className="w-14 h-14 flex items-center justify-center bg-cyan-400/10 border border-cyan-400/20 mb-6 group-hover:bg-cyan-400 group-hover:border-cyan-400 transition-all duration-400">
                  <IconComponent className="w-7 h-7 text-cyan-400 group-hover:text-black transition-colors" />
                </div>
                
                {/* Content */}
                <h3 className="text-xl font-semibold text-white mb-4 group-hover:text-cyan-400 transition-colors">
                  {service.title}
                </h3>
                <p className="text-white/60 leading-relaxed">
                  {service.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
